/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsSquarePlus: {
  name: 'square-plus';
  data: string;
} = {
  name: 'square-plus',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Zm16 0H5v14h14V5ZM8 12a1 1 0 0 1 1-1h2V9a1 1 0 1 1 2 0v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2H9a1 1 0 0 1-1-1Z" fill="currentColor"/></svg>`,
};
